export class CompanyRow {
    initalize(row, startYear, compsToComments) {
        var assignedToConv = {
            "emccleery":"Emily McCleery",
            "avisage":"Alyssa Visage",
            "dblackbourn":"Denise Blackbourn",
            "sclodfelter":"Steve Clodfelter",
            "jgardner":"Jim Gardner",
            "kjudd":"Kelli Judd",
            "avalentine":"Anastasia Valentine",
            "jmaring":"Jack Maring",
        }

        this.rawRow = row
        this.primaryName = row[0]
        this.stripedName = row[1]
        this.aliases = row[2].replaceAll(" ", "").split(",")

        const bullhornYears = row[3].split(",")
        const diceYears = row[4].split(",")
        const salesIntelYears = row[5].split(",")

        this.contacts = parseInt(row[6])
        this.itDepartmentSize = row[7]
        this.rawRevenue = (row[8] === "Unknown") ? "Unknown" : parseInt(row[8])
        this.industries = row[9]
        this.description = row[10]
        this.locations = row[11].replaceAll(",", ", ")
        this.assignedTo = row[12]
        this.formattedAssignedTo = (typeof(assignedToConv[this.assignedTo]) == "undefined") ? this.assignedTo : assignedToConv[this.assignedTo]
        this.assignmentStatus = row[13]
        this.accountManager = row[14]
        this.bullhornStatus = row[15]
        this.bullhornDateAdded = row[16]
        this.assignDate = (row[18] == "N/A") ? "1900-01-01" : row[18]
        this.formattedAssignDate = (row[18] == "N/A" && this.assignedTo != "Nobody") ? "Legacy" : row[18]
        this.jackalType = row[19]

        if (!this.jackalType.includes('ICP')) {
            if (this.jackalType.toLowerCase().includes('ver')) {
                this.jackalType = "Verified"
            } else {
                this.jackalType = "Generated"
            }
        } else {
            if (this.jackalType.toLowerCase().includes('ver')) {
                this.jackalType = "Verified (ICP)"
            } else {
                this.jackalType = "Generated (ICP)"
            }
        }

        if (this.rawRevenue != "Unknown" && this.rawRevenue >= 1) {
            this.formattedRevenue = "$" + this.rawRevenue
            for (var entry of [[1_000_000_000_000, " T"], [1_000_000_000, " B"], [1_000_000, " M"], [1_000, " K"]]) {
                var amt = entry[0]
                var letter = entry[1]
                if (this.rawRevenue >= amt) {
                    this.formattedRevenue = "$" +(this.rawRevenue / amt).toFixed(2) + letter
                    break
                }
            }
        } else {
            this.formattedRevenue = "Unknown"
        }

        if (this.industries.length >= 120) {
            this.industries = "Unknown"
        }

        if (this.industries.includes(",")) {
            this.primaryIndustry = this.industries.slice(0, this.industries.indexOf(","))
            this.primaryIndustry = this.primaryIndustry.length >= 40 ? "Unknown" : this.primaryIndustry
        } else {
            this.primaryIndustry = "Unknown"
        }

        this.bullhornConsultants = 0
        this.diceConsultants = 0 
        this.salesIntelConsultants = 0

        for (var year of bullhornYears) {
            if (parseInt(year) >= startYear) {
                this.bullhornConsultants+=1
            }
        }

        for (var year of diceYears) {
            if (parseInt(year) >= startYear) {
                this.diceConsultants+=1
            }
        }

        for (var year of salesIntelYears) {
            if (parseInt(year) >= startYear) {
                this.salesIntelConsultants+=1
            }
        }

        this.totalConsultants = this.bullhornConsultants+this.diceConsultants+this.salesIntelConsultants

        if (this.itDepartmentSize == -1 || this.itDepartmentSize > 10000) {
            this.itDepartmentSize = ">10,000"
        } else if (this.itDepartmentSize == "Unknown" || this.totalConsultants*2 > parseInt(this.itDepartmentSize)) {
            this.itDepartmentSize = "Unknown"
        } else {
            this.itDepartmentSize = parseInt(this.itDepartmentSize)
        }

        this.comments = compsToComments[this.stripedName]
        this.hiddenInTable = true
    }

    addRow(otherRow) {
        this.contacts += otherRow.contacts
        this.bullhornConsultants += otherRow.bullhornConsultants
        this.diceConsultants += otherRow.diceConsultants 
        this.salesIntelConsultants += otherRow.salesIntelConsultants
        this.totalConsultants += otherRow.totalConsultants

        for (var key of ["rawRevenue", "formattedRevenue", "industries", "primaryIndustry", "description", "locations", "accountManager", "bullhornStatus", "bullhornDateAdded", "itDepartmentSize"]) {
            if (["Unknown", "N/A", 0, "0"].includes(this[key])) {
                this[key] = otherRow[key]
            }
        }
    }
}
